exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-lead-invite-___style__inviteContainer___3Z6XY{text-align:center;border-bottom:1px solid #e5e3e3}.web-flows-lead-invite-___style__inviteContainer___3Z6XY>img{border-radius:50%;width:85px;height:85px}.web-flows-lead-invite-___style__inviteContainer___3Z6XY>h3{font-weight:400}.web-flows-lead-invite-___style__login___1Kbu1{text-align:center;font-size:1.1em;margin-bottom:0}", ""]);

// exports
exports.locals = {
	"inviteContainer": "web-flows-lead-invite-___style__inviteContainer___3Z6XY",
	"login": "web-flows-lead-invite-___style__login___1Kbu1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/lead/invite/style.css
// module id = 1360
// module chunks = 0